import {Footer} from "@/components/layouts/main/Footer";
import {Header} from "@/components/layouts/main/Header";
import {SideBar} from "@/components/layouts/main/SideBar";

import {useMemo} from "react";

import {createRoutes, userRoutes} from "@routers/lazyRoutes.jsx";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Route, Routes} from "react-router-dom";

import styles from "./styles.module.scss";

export const UserPanel = () => {
  const {t} = useTranslation();
  const {id} = useSelector((state) => state.common.candidate);
  const {sessions} = useSelector((state) => state.common.viewTabs);

  const routes = createRoutes(userRoutes);

  const userBarList = useMemo(
    () => [
      {
        id: 0,
        iconId: "profile",
        name: t("sidebar.profile"),
        link: `profile/${id}`,
      },
      {
        id: 1,
        iconId: "analytics",
        name: t("sidebar.history"),
        link:
          sessions === "certification"
            ? "analytics/certification"
            : sessions === "scenario"
              ? "analytics/scenario"
              : "analytics/product",
      },
    ],
    [t, id, sessions],
  );

  return (
    <div className={styles.userPanel}>
      <Header />

      <div className={"container-big"}>
        <div className={styles.main}>
          <SideBar list={userBarList} />

          <Routes>
            {routes &&
              routes.length > 0 &&
              routes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={route.element}
                />
              ))}
          </Routes>
        </div>
      </div>

      <Footer />
    </div>
  );
};
